<div>
    <h3>xx-user Mock Observer</h3>

    <div *ngIf="user">
        <h4>User: {{ user.firstName }} {{ user.lastName }} (ID: {{ user.id }})</h4>
    </div>

    <button *ngIf="user">Mock Server change</button>
</div>
